import { Lock, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FEATURE_LABELS } from "@/lib/billing";

// Wraps premium content. If the current user lacks `feature`, renders an upgrade wall.
export function FeatureGate({ feature, children, title, blurb }) {
  const { user, hasFeature, entitlements } = useAuth();
  if (user && entitlements === null) {
    return (
      <div className="py-16 text-center section-label text-[11px] text-zinc-600 animate-pulse" data-testid="entitlement-loading">
        Checking access…
      </div>
    );
  }
  if (hasFeature(feature)) return children;
  return <UpgradeWall feature={feature} title={title} blurb={blurb} />;
}

export function UpgradeWall({ feature, title, blurb }) {
  const { user } = useAuth();
  const label = FEATURE_LABELS[feature] || "this feature";
  return (
    <div
      className="glass-card glass-card-featured p-10 sm:p-14 text-center max-w-2xl mx-auto"
      data-testid={`upgrade-wall-${feature}`}
    >
      <span className="inline-flex h-14 w-14 items-center justify-center rounded-full border border-white/12 mb-6">
        <Lock className="h-5 w-5 text-[#9fd3ff]" strokeWidth={1.5} />
      </span>
      <div className="section-label text-[10px] text-[#9fd3ff]">Members only</div>
      <h2 className="mt-3 font-heading text-2xl sm:text-3xl font-light tracking-tight">
        {title || `Unlock ${label}`}
      </h2>
      <p className="mt-4 text-sm text-zinc-400 font-light leading-relaxed">
        {blurb ||
          `${label} is part of an MBM membership. Choose a plan to unlock it — or if you already have an active membership, make sure you're signed in.`}
      </p>
      <div className="mt-8 flex items-center justify-center gap-3">
        <Link to="/#pricing" className="btn-solid px-6 py-3 text-sm font-medium inline-flex items-center gap-2" data-testid="upgrade-view-plans">
          <Sparkles className="h-4 w-4" /> View memberships
        </Link>
        {!user && (
          <Link to="/login" className="btn-glass text-white px-6 py-3 text-sm font-medium" data-testid="upgrade-login">
            Sign in
          </Link>
        )}
      </div>
    </div>
  );
}
